import { isAdTemplateOffered } from "src/pages/ad-studio/components/is-ad-template-offered";
import { isInBrandScope, liveBrandIds } from "src/utils/brand-scope";
import type { AdStudioTemplateCard } from "src/pages/ad-studio/templates/types";

export type TemplateSelection = {
  ids: string[];
  folderIds?: string[];
  folderBrandProfileId?: string;
};

export type TemplateSelectionContext = {
  adStudioTemplateIds?: unknown;
  adStudioTemplateFolderIds?: unknown;
};

export function templateSelectionToContext(selection: TemplateSelection): {
  adStudioTemplateIds?: string[];
  adStudioTemplateFolderIds?: string[];
} {
  return {
    ...(selection.ids.length > 0 ? { adStudioTemplateIds: selection.ids } : {}),
    ...(selection.folderIds?.length
      ? { adStudioTemplateFolderIds: selection.folderIds }
      : {}),
  };
}

export function templateSelectionFromContext(
  context: TemplateSelectionContext | null | undefined,
): TemplateSelection {
  const validIds = (value: unknown) =>
    Array.isArray(value)
      ? [
          ...new Set(
            value.filter(
              (id): id is string => typeof id === "string" && id.length > 0,
            ),
          ),
        ]
      : [];
  const folderIds = validIds(context?.adStudioTemplateFolderIds);
  return {
    ids: validIds(context?.adStudioTemplateIds),
    ...(folderIds.length ? { folderIds } : {}),
  };
}

export function selectAdStudioTemplateOptions<
  Template extends Pick<
    AdStudioTemplateCard,
    "isActive" | "agentScopes" | "brandProfileAssignments" | "updatedAt"
  >,
>(templates: Template[], brandProfileId: string): Template[] {
  return templates
    .filter(
      (template) =>
        isAdTemplateOffered(template) &&
        isInBrandScope(liveBrandIds(template.brandProfileAssignments), [
          brandProfileId,
        ]),
    )
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}
